import { useEffect } from 'react'
import { Link, useNavigate } from 'react-router'
import { useSearchParams } from 'react-router'
import { toast } from 'sonner'

import { FeedbackModal } from '@/components/FeedbackModal/FeedbackModal'
import { Button } from '@/components/ui/button'
import { SetPasswordForm } from '@/forms/SetPasswordForm'
import { useDisclosure } from '@/hooks/use-disclosure'
import { AuthCard, AuthFooter, AuthLayout } from '@/layouts/AuthLayout'

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams()
  const code = searchParams.get('code')
  const email = searchParams.get('email')

  const navigate = useNavigate()
  const { isOpen: isFeedbackOpen, onToggle } = useDisclosure()

  useEffect(() => {
    if (!code || !email) {
      navigate('/auth/login')
    }
  }, [code, email, navigate])

  return (
    <AuthLayout>
      <title>Obnova hesla</title>

      <AuthCard title="Nové heslo" description="Opište kód z e-mailu a zvolte si nové heslo.">
          <SetPasswordForm
            action="/api/v2/password-resets"
            code={code}
            email={email}
            onSuccess={async (response: any) => {
              if (response.status > 400) {
                toast.error('Chyba obnovení hesla', {
                  description:
                    'Kombinace e-mailu a kódu není platná. Zkuste to prosím znovu.',
                  duration: 5000,
                  onDismiss: () => navigate('/auth/reset-password'),
                })
                return
              }

              if (response.status === 200 || response.status === 204) {
                toast.success('Heslo bylo obnoveno', {
                  description: 'Nyní se můžete přihlásit.',
                  duration: 5000,
                  onDismiss: () => navigate('/auth/login'),
                })

                navigate('/auth/login')
              }
            }}
          />
      </AuthCard>

      <AuthFooter>
        <Link
          to="/auth/login"
          className="text-sm text-muted-foreground hover:text-foreground"
        >
          Zpět na přihlášení
        </Link>

        <Button variant="link" size="sm" onClick={onToggle}>
          Zpětná vazba
        </Button>
        <FeedbackModal isOpen={isFeedbackOpen} onToggle={onToggle} />
      </AuthFooter>
    </AuthLayout>
  )
}
